import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "itemizedBills", "billsPopup", "arrow", "billsContainer"]
  static values = {
    costPerTraining: Number // Cost from the model constant
  }

  connect() {
    // Hide bills on initial load
    this.billsContainerTarget.classList.add("hidden")
    this.billsPopupTarget.classList.add("hidden")

    // Make sure outside clicks close the popup
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutside)

    // Update display on connect
    this.updateDisplay()
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside)
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.billsPopupTarget.classList.add("hidden")
      this.arrowTarget.classList.remove("rotate-180")
    }
  }

  updateDisplay() {
    const totalCost = this.costPerTrainingValue
    const roundedCost = Math.ceil(totalCost * 10) / 10

    // Update submit button text
    const span = this.submitButtonTarget.querySelector("span:last-child")
    if (span) span.textContent = `Clone Model (${roundedCost} Credits)`

    // Reveal the itemized bill
    this.billsContainerTarget.classList.remove("hidden")
    this.itemizedBillsTarget.innerHTML = this.generateItemizedBillsHTML(roundedCost)
  }

  generateItemizedBillsHTML(totalCost) {
    return `
      <div class="text-white space-y-3">
        <div class="text-lg font-medium text-gray-200 mb-3">Cost Breakdown</div>
        <div class="border border-dashed border-gray-600 rounded-lg p-4 space-y-3">
          <div class="flex justify-between items-center text-sm">
            <span>Clone Model (1 × ${totalCost} credits)</span>
            <span>${totalCost} credits</span>
          </div>
        </div>
        <div class="flex justify-between items-center pt-3 text-sm font-medium">
          <span>Total:</span>
          <span class="flex items-center gap-1">
            <svg class="w-4 h-4 text-blue-400" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
            </svg>
            ${totalCost}
          </span>
        </div>
      </div>
    `
  }

  toggleBills(event) {
    event.stopPropagation()
    this.billsPopupTarget.classList.toggle("hidden")
    this.arrowTarget.classList.toggle("rotate-180")
  }
} 